import React from "react";
import { useGetApiQuery, useGetHtmlApiQuery } from "../redux/services/apiHome";
import Loader from "../components/Loader";
import InnerBannerBreadcrumb from "../components/shared/breadcrumb/InnerBannerBreadcrumb";
import { useParams } from "react-router-dom";
import { useSelector } from "react-redux";
import { useLanguageTranslation } from "../hooks/useLanguageTranslation";
import { useGetProtectedApiDataQuery } from "../redux/services/apiSlice";

function HtmlPageByNode() {
  const { id, nid } = useParams();
  const { languageType } = useSelector((state) => state.homeSlice);
  const { getText } = useLanguageTranslation();

  const { data: rtiData = [], isLoading: rtiDataIsLoading } =
    useGetProtectedApiDataQuery({
      url: "rti",
      lang: languageType,
    });

  const rtiObj = rtiData.find((item) => item.nid === id);

  const { data: htmlData = {}, isLoading: htmlIsLoading } = useGetHtmlApiQuery({
    url: nid,
    lang: languageType,
  });

  const pageBody = htmlData?.body?.[0]?.value ?? "No content available";
  const pageTitle = htmlData?.title?.[0]?.value ?? "No content available";

  if (htmlIsLoading && rtiDataIsLoading) {
    return <Loader />;
  }

  return (
    <>
      <InnerBannerBreadcrumb
        bannerImage="/images/inner_aboutbann.jpg"
        title={getText("RTI", "आरटीआई")}
        titleLink={"/rti"}
        levelTwo={true}
        levelThree={true}
        isActive={pageTitle}
        titleTwo={rtiObj?.title}
        titleThree={pageTitle}
        titleLink2={`/rti/${id}`}
      />
      <div className="inner-container">
        <div className="container">
          <section className="ourCompany">
            <div className="container">
              <div className="row mb-5">
                <div className="col-12 col-sm-12 col-md-12 col-lg-12">
                  <div dangerouslySetInnerHTML={{ __html: pageBody }}></div>
                </div>
              </div>
            </div>
          </section>
        </div>
      </div>
    </>
  );
}

export default HtmlPageByNode;
